import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

export type GetUserParams = {
  id: string;
};

export type GetUserActorParams = {
  id: string;
};

export const performGetActors = async (api: IApiStore, params: EndpointCallParams<{}>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('neoanalytics-app/api/v1/actors/Search', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}

export const performQueryActors = async (api: IApiStore, params: EndpointCallParams<{}>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('neoanalytics-app/api/v1/actors/query', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}

export const performGetActorsSummary = async (api: IApiStore, params: EndpointCallParams<{}>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('neoanalytics-app/api/v1/actors/summary', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}

export const performGetActor = async (api: IApiStore, params: EndpointCallParams<GetUserActorParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .get(`neoanalytics-app/api/v1/actors/${payload.id}`, {
            ...rest,
            payload: { ...payload },
        })

    return req;
}
